<template>
  <div class="activity-page">
    <!-- <div class="banner">
      <img class="img-responsive" src="../Home/images/01841_03.png" alt />
    </div> -->
    <Banner loc="3" />
    <CaptionBar :title="$t('activity_page.title')" subTitle="INFORMATION" />
    <div class="goods-list c-layout">
      <router-link
        :to="{name:'activityDetail',query:{id:item.id}}"
        class="goods-item"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="img-block">
          <img :src="item.photo" alt />
        </div>
        <div class="tx">{{item.name}}</div>
        <div class="tx">{{item.publishdate ? moment(item.publishdate).format("YYYY.MM.DD") : ''}}</div>
      </router-link>
    </div>
    <!-- <Pagination
      v-if="list"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @handleCurrentChange="handleCurrentChange"
      @handlePageIndex="handlePageIndex"
    /> -->
    <Pagination
      v-if="list"
      :pageSize="pageSize"
      :pages="currentPage"
      :total="total"
      :listLoading="loading"
      @handelPaginationChange="handleCurrentChange"
    />
  </div>
</template>

<script>
import Banner from "@/components/Banner";
// import Pagination from "@/components/Pagination";
import Pagination from '@/components/Pagination/NewPagination.vue';
import CaptionBar from "@/components/CaptionBar";
import { getActivityList } from "@/api";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 9, //每页显示多少条
      list: "",
    };
  },
  async mounted() {
    this.int = this.$route.query.int || 1;
    this.getList({
      page: this.currentPage,
      count: this.pageSize,
    });
  },
  methods: {
    moment,
    handlePageIndex(val) {
      this.currentPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList({ page: val, count: this.pageSize, int: this.int });
    },
    async getList(data) {
      this.loading = true;
      let res = await getActivityList(data);
      this.list = res.share.data;
      this.total = res.share.total;
      this.loading = false;
    },
  },
  components: {
    Pagination,
    CaptionBar,
    Banner
  },
};
</script>

<style  lang='less'>
.activity-page {
  a {
    text-decoration: none;
    color: var(---unnamed-color-707070);
  }
  .caption-bar-comp {
    transform: translateY(-27px);
    .caption-line {
      width: 100%;
    }
    @media (max-width: 992px) {
      transform: translateY(-13px);
    }
  }
  // .goods-list {
  //   display: flex;
  //   flex-wrap: wrap;
  //   .goods-item {
  //     margin-right: 30px;
  //     margin-bottom: 30px;
  //     font-size: 16px;
  //     line-height: 24px;
  //     img {
  //       display: block;
  //       margin-bottom: 10px;
  //       width: 350px;
  //       height: 280px;
  //       object-fit: cover;
  //     }
  //     .tx {
  //       padding-top: 6px;
  //     }
  //   }
  //   .goods-item:nth-child(3n) {
  //     margin-right: 0;
  //   }
  //   @media (max-width: 576px) {
  //     .goods-item {
  //       margin-right: 30px;
  //       margin-bottom: 30px;
  //       font-size: 16px;
  //       line-height: 24px;
  //       img {
  //         display: block;
  //         margin-bottom: 10px;
  //         width: 350px;
  //         height: 280px;
  //         object-fit: cover;
  //       }
  //       .tx {
  //         padding-top: 6px;
  //       }
  //     }
  //     .goods-item:nth-child(3n) {
  //       margin-right: 0;
  //     }
  //   }
  // }
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    .goods-item {
      flex: 0 0 calc(33.333333% - 20px);
      margin-right: 30px;
      margin-bottom: 10px;
      .img-block {
        width: 100%;
        padding-top: calc(100%/350*280);
        position: relative;
        overflow: hidden;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .tx {
        margin-bottom: 6px;
      }
    }
    .goods-item:nth-child(3n) {
      margin-right: 0;
    }
    @media (max-width: 992px) {
      .goods-item {
        flex: 0 0 calc(50% - 15px);
        margin-right: 30px;
        // margin-bottom: 30px;
      }
      .goods-item:nth-child(3n) {
        margin-right: 30px;
      }
      .goods-item:nth-child(2n) {
        margin-right: 0;
      }
    }
    @media (max-width: 576px) {
      padding: 0 20px;
      .goods-item {
        flex: 0 0 100%;
        margin-right: 0 !important;
        // margin-bottom: 10px;
        .img-block { 
          padding-top: calc(100%/350*200);
        }
      }
    }
  }
  .pagination-comp {
    margin: 25px;
  }
}
</style>
